import React from 'react';
interface TestimonialProps {
  name: string;
  title: string;
  quote: string;
  imageUrl?: string;
}
export function Testimonial({
  name,
  title,
  quote,
  imageUrl
}: TestimonialProps) {
  return <div className="bg-blue-50 p-5 my-4 rounded-lg border-l-4 border-blue-400" data-id="element-141">
      <p className="italic mb-3" data-id="element-142">"{quote}"</p>
      <div className="flex items-center" data-id="element-143">
        {imageUrl ? <img src={imageUrl} alt={`${name} profile`} className="h-12 w-12 rounded-full object-cover mr-3" data-id="element-144" /> : <div className="h-8 w-8 rounded-full bg-blue-200 flex items-center justify-center text-blue-700 mr-3" data-id="element-145">
            {name.charAt(0)}
          </div>}
        <div data-id="element-146">
          <p className="font-bold text-gray-900" data-id="element-147">{name}</p>
          <p className="text-sm text-gray-600" data-id="element-148">{title}</p>
        </div>
      </div>
    </div>;
}